import { gql } from 'apollo-angular'

export default gql`
  mutation edit_survey_test_by_pk($id: Int!, $_set: survey_test_set_input) {
    update_survey_test(where: { id: { _eq: $id } }, _set: $_set) {
      affected_rows
      returning {
        id
      }
    }
  }
`
